<div class="select-container" [ngClass]="{'error': error}">
  @if (label) {
    <label [for]="selectId" [id]="selectId + '-label'" class="select-label">{{ label }}@if (required) {<span class="required-mark" aria-hidden="true">*</span>}</label>
  }

  <p-select
    [options]="options"
    [(ngModel)]="selectedOption"
    [placeholder]="placeholder || ('common.placeholders.select' | transloco)"
    [disabled]="disabled"
    [required]="required"
    [ngClass]="[size, isDropdownOpen ? 'menu-open' : '']"
    class="custom-select"
    (onShow)="onDropdownOpen()"
    (onHide)="onDropdownClose()"
    (onBlur)="onBlur()"
    [id]="selectId"
    [ariaLabelledBy]="label ? selectId + '-label' : undefined"
    optionLabel="label"
    optionValue="value"
    [filter]="filter"
    [filterPlaceholder]="filterPlaceholder || ('common.placeholders.search' | transloco)"
    filterBy="label"
    [appendTo]="appendTo"
    (onFilter)="filterChange.emit($event.filter ?? '')"
  >
    <ng-template pTemplate="selectedItem" let-option>
      @if (showIcon && option?.icon) {
        <div class="flex align-items-center gap-2">
          <img [src]="option.icon" class="flag-icon" />
          <span>{{ option.label }}</span>
        </div>
      } @else {
        <span>{{ option?.label }}</span>
      }
    </ng-template>
    <ng-template pTemplate="item" let-option>
      @if (showIcon && option?.icon) {
        <div class="flex align-items-center gap-2">
          <img [src]="option.icon" class="flag-icon" />
          <span>{{ option.label }}</span>
          @if (option?.hasPayroll) {
            <lucide-icon name="CircleCheck" class="payroll-check-icon" [size]="24" [color]="getPayrollIconColor(option?.payrollStatus)"></lucide-icon>
          }
        </div>
      } @else {
        <div class="flex align-items-center gap-2" style="width: 100%; justify-content: space-between;">
          <span>{{ option?.label }}</span>
          @if (option?.hasPayroll) {
            <lucide-icon name="CircleCheck" class="payroll-check-icon" [size]="24" [color]="getPayrollIconColor(option?.payrollStatus)"></lucide-icon>
          }
        </div>
      }
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      @if (loading) {
        <span class="select-spinner"></span>
      } @else {
        <lucide-icon [name]="isDropdownOpen ? 'ChevronUp' : 'ChevronDown'" class="custom-icon"></lucide-icon>
      }
    </ng-template>
  </p-select>

  @if (error) {
    <div class="error-message">{{ errorMessage || ('common.messages.requiredField' | transloco) }}</div>
  }
</div>